import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import EndOfStayAppreciationsSummaryPage from './end-of-stay-appreciations-summary'

export const endOfStayAppreciationsSummaryRoutes: Route[] = [
  {
    path: Paths.SURVEY_END_OF_STAY_APPRECIATIONS_SUMMARY_PAGE,
    element: <EndOfStayAppreciationsSummaryPage />,
    roles: [RoleEnum.ADMIN]
  }
]
